<template>
  <div class="login-page login-1">
    <div class="login-wrapper">
      <div class="login-box">
        <div class="logo-main">
          <a href="/admin">
            <img src="/assets/img/lacolima.png" alt="Laraspace Logo">
          </a>
        </div>
        <router-view/>
        <div class="page-copyright">
          <p>Implementado por
            <a href="http://xelacode.com.gt/" target="_blank">XelaCode</a>
          </p>
          <p>{{ year }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">

export default {
  data () {
    return {
      year: ''
    }
  },
  methods: {
    TomarFecha () {
      var fecha = new Date();
      this.year = fecha.getFullYear();
    },
  },
  mounted () {
    this.TomarFecha()
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/layouts/LayoutLogin.vue